import { render } from "./AnunturiSideBar.vue?vue&type=template&id=572223d7"
import script from "./AnunturiSideBar.vue?vue&type=script&lang=js"
export * from "./AnunturiSideBar.vue?vue&type=script&lang=js"

import "./AnunturiSideBar.vue?vue&type=style&index=0&id=572223d7&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__